/* Campaign UI only. Existing configurator, save payload and email integration stay in charge. */
(() => {
  'use strict';
  if (!window.pv2BlackWeek?.enabled) return;
  const buySelector = '#pv2-add-to-cart, #pv2-summary-add-to-cart, #pv2-summary-modal-add-to-cart, #sticky-summary-cart-btn';
  const formSelector = '#pv2-design-overlay .old-add-to-cart-form form';
  // Capture before existing button handlers. This is a storefront UI lock, not checkout access control.
  document.addEventListener('click', event => {
    if (event.target.closest(buySelector)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches(formSelector)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  function init() {
    if (document.getElementById('pv2-bw-notice')) return;
    const overlay = document.getElementById('pv2-design-overlay');
    const right = overlay?.querySelector('.pv2-design-right');
    if (!right) return;
    const vipButton = () => '<button type="button" class="pv2-bw-vip" data-pv2-bw-vip>Tilmeld dig VIP-listen</button>';
    const note = document.createElement('section');
    note.id = 'pv2-bw-notice'; note.className = 'pv2-bw-notice';
    note.setAttribute('aria-label', 'Black Week og VIP-adgang');
    note.innerHTML = '<span class="pv2-bw-eyebrow">BLACK WEEK · VIP-ADGANG</span>' +
      '<h2><svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="11" rx="3" stroke="currentColor" stroke-width="1.7"/><path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="1.7"/></svg>Dit Black Week-tilbud er låst</h2>' +
      '<p>VIP-salget åbner <strong>22. november kl. 08.00.</strong> Lav dit design nu, og gem det på mail, så du er klar til at købe.</p>' +
      vipButton() + '<p class="pv2-bw-small">Tilmelding til VIP-listen sker separat fra at gemme dit design.</p>';
    right.prepend(note);
    // Both placements use this same markup and shared CSS; replace the old product banner.
    const productRight = document.querySelector('.pv2-feature-right');
    if (productRight && !productRight.querySelector('.pv2-bw-product-notice')) {
      const productNotice = note.cloneNode(true);
      productNotice.removeAttribute('id');
      productNotice.classList.add('pv2-bw-product-notice');
      const previousBanner = productRight.querySelector('.pv2-title-box.black-week');
      if (previousBanner) previousBanner.replaceWith(productNotice);
      else productRight.prepend(productNotice);
    }
    const titleBox = right.querySelector('.pv2-title-box');
    if (titleBox) {
      const save = document.createElement('button'); save.type = 'button';
      save.className = 'pv2-bw-save'; save.dataset.pv2BwSave = '';
      save.textContent = 'Gem dit design'; titleBox.append(save);
    }
    function openSave() {
      const trigger = document.getElementById('pv2-summary-overview-btn');
      if (trigger) trigger.click();
    }
    document.addEventListener('click', event => {
      if (event.target.closest('[data-pv2-bw-save]')) openSave();
      if (event.target.closest('[data-pv2-bw-vip]')) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', window.pv2BlackWeek.vipFormId]);
      }
    });
    // Existing sticky heart already opens the save dialog; add a visible label.
    const stickySave = document.getElementById('sticky-summary-overview-btn');
    if (stickySave && !stickySave.querySelector('.pv2-bw-save-label')) {
      const label = document.createElement('span'); label.className = 'pv2-bw-save-label';
      label.textContent = 'Gem dit design'; stickySave.append(label);
    }
    const productSticky = document.getElementById('pv2-sticky-open');
    if (productSticky) {
      const textNodes = Array.from(productSticky.childNodes).filter(node => node.nodeType === 3);
      textNodes.forEach((node, index) => { node.textContent = index === 0 ? 'Design og gem ' : ''; });
      if (!textNodes.length) productSticky.prepend(document.createTextNode('Design og gem '));
    }
    const modal = document.getElementById('pv2-summary-modal');
    const setText = (selector, value) => { const node = modal?.querySelector(selector); if (node) node.textContent = value; };
    setText('.pv2-saved-eyebrow', '');
    setText('.pv2-saved-header > p', 'Få et link til dit design på mail.');
    setText('.pv2-save-panel-title', 'Dit design. Klar til Black Week.');
    setText('.pv2-save-panel-intro', 'Få dit design og et personligt link på mail, så du nemt kan finde det igen den 22. november.');
    setText('.pv2-saved-price-note', 'Dit gemte design reserverer ikke et drivhus eller en pris. Pris og lagerstatus opdateres, når du åbner linket igen.');
    const aside = modal?.querySelector('.pv2-summary-btnwrap');
    if (aside) {
      const reminder = document.createElement('div'); reminder.className = 'pv2-bw-vip-reminder';
      reminder.hidden = true;
      reminder.innerHTML = '<strong>Næste skridt: Få VIP-adgang</strong><p>VIP-salget åbner <b>22. november kl. 08.00.</b></p><p>At gemme dit design tilmelder dig ikke VIP-listen.</p>' + vipButton() + '<button type="button" class="pv2-bw-already" data-pv2-bw-done>Jeg er allerede tilmeldt</button>';
      aside.append(reminder);
      setupSaveFlow(modal, reminder);
    }
    const summary = document.getElementById('pv2-summary-box');
    if (summary) {
      const text = document.createElement('p'); text.className = 'pv2-bw-summary-note';
      text.textContent = 'Gem dit design nu. Køb fra 22. november kl. 08.00 med VIP-adgang.';
      document.getElementById('pv2-summary-overview-btn')?.before(text);
    }
    for (const button of document.querySelectorAll(buySelector)) { button.hidden = true; button.setAttribute('aria-hidden', 'true'); button.tabIndex = -1; }
    syncStickyTotal();
  }
  function syncStickyTotal() {
    const total = document.getElementById('pv2-summary-total');
    const sticky = document.getElementById('sticky-summary-price');
    if (!total || !sticky) return;
    const sync = () => {
      const value = total.textContent.trim();
      if (value && sticky.textContent !== value) sticky.textContent = value;
    };
    // The main total includes all add-ons and shelf discounts. Never recalculate here.
    // Watch both fields because the legacy sticky routine can overwrite its own field
    // with the base variant price even when the canonical total has not changed.
    const observer = new MutationObserver(sync);
    observer.observe(total, { childList: true, characterData: true, subtree: true });
    observer.observe(sticky, { childList: true, characterData: true, subtree: true });
    sync();
  }
  function setupSaveFlow(modal, reminder) {
    const form = modal.querySelector('#pv2-save-form');
    const inner = modal.querySelector('.pv2-summary-modal-inner');
    if (!form || !inner) return;
    modal.classList.add('pv2-bw-flow');
    const steps = document.createElement('ol'); steps.className = 'pv2-bw-flow-steps';
    steps.setAttribute('aria-label', 'Gem dit design og få VIP-adgang');
    const first = document.createElement('li'); first.textContent = '1 · Gem dit design';
    const second = document.createElement('li'); second.textContent = '2 · Få VIP-adgang';
    steps.append(first, second); inner.prepend(steps);
    const list = modal.querySelector('#pv2-summary-list');
    const overview = modal.querySelector('.pv2-saved-overview');
    let details;
    if (list && overview) {
      details = document.createElement('details'); details.className = 'pv2-bw-flow-details';
      const toggle = document.createElement('summary'); toggle.textContent = 'Se alle dine valg';
      details.append(toggle); overview.insertBefore(details, list); details.append(list);
    }
    const opening = document.createElement('p'); opening.className = 'pv2-bw-flow-opening';
    opening.textContent = 'VIP-salget åbner 22. november kl. 08.00. Du får mulighed for at tilmelde dig, når dit design er sendt.';
    form.append(opening);
    const disclaimer = document.createElement('p'); disclaimer.className = 'pv2-bw-flow-disclaimer';
    disclaimer.textContent = 'Designet reserverer ikke lager eller pris. At gemme dit design tilmelder dig ikke VIP-listen.';
    inner.append(disclaimer);
    const sync = () => {
      // Only the existing save handler can confirm success after Make returns ok:true.
      const success = form.dataset.state === 'success';
      const changed = modal.dataset.pv2SaveStep !== (success ? 'vip' : 'save');
      modal.dataset.pv2SaveStep = success ? 'vip' : 'save';
      reminder.hidden = !success;
      if (success) { first.removeAttribute('aria-current'); second.setAttribute('aria-current', 'step'); }
      else { second.removeAttribute('aria-current'); first.setAttribute('aria-current', 'step'); }
      if (changed) { inner.scrollTop = 0; if (details) details.open = false; }
    };
    new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['data-state'] });
    modal.addEventListener('click', event => {
      if (event.target.closest('[data-pv2-bw-done]')) document.getElementById('pv2-summary-close')?.click();
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
